const PublicWebsiteConstants = {
  GET_CONFIGURATION_OPTION_SUCCESS: "GET_CONFIGURATION_OPTION_SUCCESS",
  GET_CONFIGURATION_OPTION_FAILURE: "GET_CONFIGURATION_OPTION_FAILURE",
  SAVE_UPDATE_CONFIGURATION_OPTION_SUCCESS:
    "SAVE_UPDATE_CONFIGURATION_OPTION_SUCCESS",
  SAVE_UPDATE_CONFIGURATION_OPTION_FAILURE:
    "SAVE_UPDATE_CONFIGURATION_OPTION_FAILURE",

  GET_EQUIPMENT_PUBLIC_INFO_SUCCESS: "GET_EQUIPMENT_PUBLIC_INFO_SUCCESS",
  GET_EQUIPMENT_PUBLIC_INFO_FAILURE: "GET_EQUIPMENT_PUBLIC_INFO_FAILURE",

  DOWNLOAD_DOC_SUCCESS: "DOWNLOAD_DOC_SUCCESS",
  DOWNLOAD_DOC_FAILURE: "DOWNLOAD_DOC_FAILURE",

  CREATE_TICKET_SUCCESS: "CREATE_TICKET_SUCCESS",
  CREATE_TICKET_FAILURE: "CREATE_TICKET_FAILURE",

  GET_TITLE_SUCCESS: "GET_TITLE_SUCCESS",
  GET_TITLE_FAILURE: "GET_TITLE_FAILURE",

  GET_TITLE_DESCRIPTION_SUCCESS: "GET_TITLE_DESCRIPTION_SUCCESS",
  GET_TITLE_DESCRIPTION_FAILURE: "GET_TITLE_DESCRIPTION_FAILURE",

  GET_EQUIP_GRP_CONF_SUCCESS: "GET_EQUIP_GRP_CONF_SUCCESS",
  GET_EQUIP_GRP_CONF_FAILURE: "GET_EQUIP_GRP_CONF_FAILURE",
};
export default PublicWebsiteConstants;
